import { AlertDialog as BaseAlertDialog } from '@base-ui/react';

import { useHandle } from './AlertDialog.hooks';
import { AlertDialogActions } from './AlertDialogActions';
import { AlertDialogBody } from './AlertDialogBody';
import { AlertDialogDescription } from './AlertDialogDescription';
import { AlertDialogTitle } from './AlertDialogTitle';

export const AlertDialog = {
  Root: BaseAlertDialog.Root,
  Trigger: BaseAlertDialog.Trigger,
  Body: AlertDialogBody,
  Title: AlertDialogTitle,
  Description: AlertDialogDescription,
  Actions: AlertDialogActions,
  Close: BaseAlertDialog.Close,
  useHandle,
};
